import React, { Component } from 'react';
import Section from '../../layout/Section';
import ciberseguridad from '../../assets/img/vector/ciberseguridad.svg';
import fortinet from '../../assets/img/brand/fortinet.png';
import SectionContainer from '../../subcomponents/SectionContainer';

import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import imgBody1 from '../../assets/img/contenido/firewall.jpg';
import img1 from '../../assets/img/flat/firewall1.svg';
import img2 from '../../assets/img/flat/firewall2.svg';
import img3 from '../../assets/img/flat/firewall3.svg';
import IconBlock from '../../subcomponents/IconBlock28';

class CiberSeguridad extends Component {
  componentDidMount() {
    document.title = 'Firewall - Insacom';
  }

  render() {
    const content = [
      {
        id: 1,
        title: 'Continuidad Operacional',
        description: 'Reduce Amenazas y Riesgos',
        img: img1
      },
      {
        id: 2,
        title: 'Prevención Automática',
        description: 'Miles de amenazas detectadas en tiempo real',
        img: img2
      },
      {
        id: 3,
        title: 'Personal Certificado',
        description: 'Manos expertas al control de la seguridad',
        img: img3
      }
    ];

    const descripcion =
      'Seguridad Perimertral para tu red corporativa, la cual permitirá que tus recursos tecnológicos estén más seguros, controlando las amenazas internas y externas para que tu empresa esté siempre conectada segura y sin interrupciones.';
    return (
      <Section asuntoContacto={'Firewall'}>
        <SectionContainer paddingBottom={'0px'}>
          <ImageText image={ciberseguridad} title="Firewall" description={descripcion}>
            <div className="d-flex flex-wrap">
              <div className="align-self-center">
                <img src={fortinet} alt="Fortinet" style={{ height: '80px', paddingBottom: 20 }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer grey>
          <IconBlock content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer>
          <TextImage image={imgBody1} title="Características">
            <ul className="list-unstyled mb-0">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Levantamiento de requerimientos.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Diseño de solución de seguridad.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Implementación, operación y soporte especializado.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  IPS: Control automatizado de amenazas con FortiGuard.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  WebFilter: Priorización o bloqueo de contenido Web.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Acceso seguro mediante VPN para teletrabajo.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  App control: Priorización o bloqueo de Aplicaciones.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Antivirus: Prevención de virus mediante inspección de tráfico.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Botnet DB: Protéjase automáticamente de sitios y aplicaciones relacionados a
                  Botnets.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  SD-WAN: Enrutamiento avanzado y optimización de WAN con el menor costo del
                  mercado.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default CiberSeguridad;



// WEBPACK FOOTER //
// ./src/sections/telecomunicaciones/CiberSeguridad.js